module.exports = fox._r("images/slides/slide_3_4.jpg", __webpack_public_path__ + "images/slides/slide_3_4.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_3_4.jpg
// module id = 519
// module chunks = 2